import { auth } from '../firebase/config';

const MAIL_API_BASE = 'https://mail.ieum.in/api/ieum-mail';
let unreadCountsRequest = null;

const request = async (path, options = {}) => {
  const user = auth.currentUser;
  if (!user) throw new Error('로그인이 필요합니다.');
  const token = await user.getIdToken();
  const response = await fetch(`${MAIL_API_BASE}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
  });
  if (response.status === 204) return null;
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.error || '메일 서버 요청에 실패했습니다.');
    error.code = payload.code || '';
    error.status = response.status;
    throw error;
  }
  return payload;
};

const queryString = (params) => {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, String(value));
  });
  const text = query.toString();
  return text ? `?${text}` : '';
};

export const getMailSession = () => request('/session');
export const getMailUnreadCounts = () => {
  if (!unreadCountsRequest) {
    unreadCountsRequest = request('/counts').finally(() => { unreadCountsRequest = null; });
  }
  return unreadCountsRequest;
};

export const createOwnMailbox = (mailId) => request('/settings/mailbox', {
  method: 'POST', body: JSON.stringify({ mailId }),
});

export const updateMailSignature = (signature) => request('/settings/signature', {
  method: 'PUT', body: JSON.stringify(signature),
});

export const listMailContacts = () => request('/contacts');

export const saveMailContact = (contact) => request('/contacts', {
  method: 'PUT', body: JSON.stringify(contact),
});

export const deleteMailContact = (email) => request(`/contacts/${encodeURIComponent(email)}`, {
  method: 'DELETE',
});

export const listMailMessages = (params) => request(`/messages${queryString(params)}`);

export const readMailMessage = (uid, params) => request(`/messages/${encodeURIComponent(uid)}${queryString(params)}`);

export const readMailMessageContent = (uid, params) => request(`/messages/${encodeURIComponent(uid)}/content${queryString(params)}`);

export const sendMailMessage = (message) => request('/messages/send', {
  method: 'POST', body: JSON.stringify(message),
});

export const saveMailDraft = (message) => request('/messages/drafts', {
  method: 'POST', body: JSON.stringify(message),
});

export const updateMailMessages = (params, action, uids, sender = '') => request(`/messages/actions${queryString(params)}`, {
  method: 'PATCH', body: JSON.stringify({ action, uids, sender }),
});

export const deleteMailMessage = (uid, params) => request(`/messages/${encodeURIComponent(uid)}${queryString(params)}`, {
  method: 'DELETE',
});

export const removeSpamSender = (sender, address = '') => request(`/settings/spam-senders/${encodeURIComponent(sender)}${queryString({ address })}`, {
  method: 'DELETE',
});

export const listManagedMailboxes = () => request('/admin/mailboxes');

export const createManagedMailbox = (mailId, ownerProfileId) => request('/admin/mailboxes', {
  method: 'POST', body: JSON.stringify({ mailId, ownerProfileId }),
});

export const updateManagedMailbox = (id, fields) => request(`/admin/mailboxes/${encodeURIComponent(id)}`, {
  method: 'PATCH', body: JSON.stringify(fields),
});

export const deleteManagedMailbox = (id) => request(`/admin/mailboxes/${encodeURIComponent(id)}`, {
  method: 'DELETE',
});

export const filesToAttachments = async (files) => Promise.all(Array.from(files || []).map((file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve({
    filename: file.name,
    contentType: file.type || 'application/octet-stream',
    contentBase64: String(reader.result || '').split(',')[1] || '',
  });
  reader.onerror = () => reject(new Error(`${file.name} 파일을 읽지 못했습니다.`));
  reader.readAsDataURL(file);
})));
